module.exports = __webpack_public_path__ + "static/media/Volcano.b399deba.jpg";